import { Navigate, Outlet } from 'react-router-dom'
import { useHandbookAccess } from '../../hooks/handbook/useHandbookAccess'

export default function HandbookAccessGate() {
  const { ready, allowed } = useHandbookAccess()
  if (!ready) return null
  return allowed ? <Outlet /> : <Navigate to="/" replace />
}
